export default __webpack_public_path__ + "static/media/1945.e1222f1e.png";